import ContactForm from "./ContactForm";
import CustomFields from "./CustomFields";
import ItemName from "./ItemName";
import Notes from "./Notes";
import PasswordOTP from "./PasswordOTP";
import PersonalForm from "./PersonalForm";
import SeedPhrase from "./SeedPhrase";
import SelectFolder from "./SelectFolder";
import Attachments from "./Attachments";
import AlertWarning from "./AlertWarning";
import WebsiteAddresses from "./WebsiteAddresses";
import Fido2Credentials from "./Fido2Credentials";

const cipherFormItemComponents = {
  ContactForm,
  CustomFields,
  ItemName,
  Notes,
  PasswordOTP,
  PersonalForm,
  SeedPhrase,
  SelectFolder,
  Attachments,
  AlertWarning,
  WebsiteAddresses,
  Fido2Credentials
}

export default cipherFormItemComponents